// vue
import Vue from 'vue';
// bootstrap
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import './css/custom.css';
import './styles/appStyles.scss';
// progressbar
import 'nprogress/nprogress.css';
// applicatie imports
import App from './App.vue';
import router from './router/portal';
import store from './store';
// services
import nedglobeApi from './services/nedglobeapi';
import createPolygonService from './services/polygon';
import createSystemService from './services/system';

// Internationalization plugin
import i18n from './i18n';

import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import usageDirective from './services/utilities/usageRecordPlugin';

const appInsights = new ApplicationInsights({
    config: {
        instrumentationKey: process.env.VUE_APP_INSIGHTS_INSTRUMENTATION_KEY || '1045db85-8b04-4f95-82df-cadbd300fad1'
        /* ...Other Configuration Options... */
    }
});
appInsights.loadAppInsights();
store.commit('SET_APPLICATION_INSIGHTS', appInsights);
window.onload = function () {
    store.dispatch('trackPageUsageStart', '/portal');
    window.addEventListener('beforeunload', function (e) {
        store.dispatch('trackPageUsageStop', '/portal');
    });
};

Vue.config.errorHandler = (err, vm) => {
    appInsights.trackException(err);
    console.error('customerror', err);
};

Vue.config.productionTip = false;

const polygonService = createPolygonService(nedglobeApi);
const systemService = createSystemService();

Vue.use(BootstrapVue);
Vue.use(usageDirective(store));

new Vue({
    router,
    store: store,

    // services
    nedglobeApi,
    polygonService,
    systemService,
    i18n,
    render: h => h(App)
}).$mount('#app');
